var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flow-margin-left flow-badge w3-round-medium font-weight-bold flow-user-role",class:_vm.roleLwr},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.roleLwr))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }